/* Session-stable rotation within each Shopify pagination page. Never changes
 * collection membership, search relevance or a shopper's explicit sort choice.
 * Page boundaries stay intact: infinite scroll cannot duplicate or omit items. */
(() => {
  if (window.Shopify?.designMode) return;
  let seed;
  try {
    seed = sessionStorage.getItem('tc-collection-rotation-v1');
    if (!seed) {
      seed = crypto.getRandomValues(new Uint32Array(1))[0].toString();
      sessionStorage.setItem('tc-collection-rotation-v1', seed);
    }
  } catch { return; } // Preserve native ordering when session storage is unavailable.

  const score = (value) => {
    let hash = 2166136261;
    for (const char of value) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
    hash ^= hash >>> 16;
    hash = Math.imul(hash, 0x85ebca6b);
    hash ^= hash >>> 13;
    return hash >>> 0;
  };
  const connected = new WeakSet();
  function connect(grid) {
    if (connected.has(grid)) return;
    connected.add(grid);
    const observer = new MutationObserver(rotate);
    const observe = () => observer.observe(grid, {
      childList: true, attributes: true, attributeFilter: ['data-tc-explicit-sort']
    });
    function rotate() {
      if (grid.dataset.tcExplicitSort) return;
      const pages = new Map();
      for (const card of grid.children) {
        if (!card.matches('li[data-product-id][data-page]')) continue;
        const page = card.dataset.page;
        if (!pages.has(page)) pages.set(page, []);
        pages.get(page).push(card);
      }
      observer.disconnect();
      for (const [page, cards] of pages) {
        const ordered = [...cards].sort((a, b) => {
          const prefix = `${seed}:${grid.dataset.tcRotation}:${page}:`;
          return score(prefix + a.dataset.productId) - score(prefix + b.dataset.productId)
            || a.dataset.productId.localeCompare(b.dataset.productId);
        });
        if (ordered.every((card, i) => card === cards[i])) continue;
        const anchor = document.createComment('collection rotation');
        grid.insertBefore(anchor, cards[0]);
        // Horizon custom elements abort listeners when disconnected. Reusing a
        // moved instance can leave quick-add listeners permanently aborted.
        // Fresh instances rehydrate normally; this runs once for each new page,
        // never again while its ordering remains unchanged.
        for (const card of ordered) {
          grid.insertBefore(card.cloneNode(true), anchor);
          card.remove();
        }
        anchor.remove();
      }
      observe();
    }
    rotate();
    observe();
  }
  function scan(root) {
    if (root.matches?.('[data-tc-rotation]')) connect(root);
    root.querySelectorAll?.('[data-tc-rotation]').forEach(connect);
  }
  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && !node.matches('li[data-product-id]')) scan(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
